// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n", ""]);
// Exports
exports.locals = {
	"color1": "#7d8c6d",
	"color2": "#72b1c8",
	"color3": "#236192",
	"color4": "#0b1f2c",
	"color5": "#622650",
	"color6": "#eb6852",
	"color7": "#f6dc6b",
	"highlighted1": "#a3ae97",
	"highlighted2": "#a9cfdd",
	"highlighted3": "#338ace",
	"highlighted4": "#1a4a69",
	"highlighted5": "#993b7d",
	"highlighted6": "#f3a497",
	"highlighted7": "#faedb3",
	"hover1": "#30362a",
	"hover2": "#2d6174",
	"hover3": "#050f17",
	"hover4": "#000",
	"hover5": "#000",
	"hover6": "#932411",
	"hover7": "#bd9b0b"
};
module.exports = exports;
